import * as React from "react";
import { Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { RatingSummary } from "@/components/reviews/RatingSummary";
export default function IgnitingYourVision() {
  return <section data-section-id="227224" id="hero" className="bg-background text-foreground relative min-h-[85svh] flex flex-col justify-center overflow-hidden py-16 md:py-24 lg:py-28 border-b border-border">
      {/* Background image & restrained dark token overlay */}
      <div className="absolute inset-0 w-full h-full pointer-events-none">
        <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685663/img/construction_sparks_timber.png)] bg-cover bg-center bg-no-repeat" />
        <div className="absolute inset-0 bg-background/85" />
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="max-w-3xl text-left">
          <h1 className="font-serif font-normal text-3xl sm:text-5xl md:text-6xl lg:text-7xl leading-[1.1] tracking-tight text-foreground mb-5">
            Remodelling, flooring, painting and repairs in Dumfries, VA
          </h1>

          <p className="text-lg md:text-xl text-muted-foreground font-sans mb-8 leading-relaxed max-w-2xl">
            Straightforward trade work, clear scheduling, and dependable execution for your home.
          </p>

          <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-4 mb-8">
            <Button size="lg" variant="default" className="h-12 px-8 text-base font-medium rounded-xs shadow-none" asChild>
              <Link to="/BookAppointmentPage">Book Appointment</Link>
            </Button>

            <Button size="lg" variant="outline" className="h-12 px-8 text-base font-medium rounded-xs border border-border bg-secondary/80 hover:bg-secondary text-secondary-foreground shadow-none" asChild>
              <a href="tel:+15712496482" className="inline-flex items-center justify-center gap-2">
                <Phone className="size-4 text-primary shrink-0" strokeWidth={2} />
                <span>Call +1 (571) 249-6482</span>
              </a>
            </Button>
          </div>

          <div className="flex flex-wrap items-center gap-4 sm:gap-6 pt-6 border-t border-border">
            <RatingSummary />
            <span className="text-xs font-mono uppercase tracking-widest text-muted-foreground">
              Mon-Sat, 7am - 7pm
            </span>
            <span className="hidden sm:inline-block h-3 w-px bg-border" aria-hidden="true" />
            <span className="text-xs font-mono uppercase tracking-widest text-muted-foreground">
              Dumfries, Virginia and the surrounding area
            </span>
          </div>
        </div>
      </div>
    </section>;
}